export const dpViewType_MultivarList = 'multivar-list';
export const dpViewType_MultivarAndValuesList = 'multivar-and-value-list';
export const dpViewTypes = [dpViewType_MultivarList, dpViewType_MultivarAndValuesList];
//# sourceMappingURL=types.js.map